module.exports = __webpack_public_path__ + "static/img/left-bg.c0469f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left-bg.jpg
// module id = mW6j
// module chunks = 3